import { GenericCollectionFactory } from ".";
import { BUDGETS_GENERIC_IDS } from "../_constants/generics.constants";

export const EntryCollection = GenericCollectionFactory(BUDGETS_GENERIC_IDS.ENTRIES, "uid");